// extracted by mini-css-extract-plugin
module.exports = {"description":"jgp-FurTH"};